import { FC } from 'react';

import { ImageIcon, PdfIcon, VideoIcon, ZipIcon } from 'assets/icons';
import { FileType, FileTypeValue } from 'types/Files.types';
type ThumbnailNameProp = {
  name: string;
  type: FileTypeValue;
  className?: string;
  textClassName?: string;
};

const ThumbnailName: FC<ThumbnailNameProp> = ({
  name = '',
  type = FileType.IMAGE,
  className = '',
  textClassName = ''
}) => {
  const renderFileIcon = () => {
    if (type === FileType.IMAGE) {
      return <ImageIcon title='image-icon' className='mt-0.75 ' />;
    } else if (type === FileType.VIDEO) {
      return (
        <VideoIcon
          title='video-icon'
          className='w-4 h-4 md:mt-0.1rem mt-0.75 '
        />
      );
    } else if (type === FileType.ZIP) {
      return (
        <ZipIcon title='zip-icon' className='w-4 h-4 md:mt-0.1rem mt-0.75' />
      );
    } else {
      return (
        <PdfIcon title='pdf-icon' className='w-4 h-4 md:mt-0.1rem mt-0.75' />
      );
    }
  };

  return (
    <div className={`flex ${className}`}>
      <div className='flex-shrink-0'>{renderFileIcon()}</div>
      <div className='min-w-0 ml-1.5 flex items-center'>
        <p className={`${textClassName}`}>{name}</p>
      </div>
    </div>
  );
};

export default ThumbnailName;
